import { ReactNode } from 'react';
import './ApplicationAnnouncementWrapper.scss';

interface IApplicationAnnouncementWrapperProps {
  icon?: ReactNode;
  description?: string;
  action?: ReactNode;
}

const ApplicationAnnouncementWrapper = ({
  icon,
  description,
  action,
}: IApplicationAnnouncementWrapperProps) => {
  return (
    <div className="application-announcement-wrapper">
      <div className="application-announcement">
        {icon}
        <div className="application-announcement-content">{description}</div>
        <div className="application-announcement-action">{action}</div>
      </div>
    </div>
  );
};

export default ApplicationAnnouncementWrapper;
